/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';

export function getCodeBlocks(feature: BaseNode): CodeBlock[] {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const TABLE = project.getFeature(feature.getSettingValue('TABLE'));
    if (!TABLE) {
        return blocks;
    }
    const TABLE_NAME = TABLE.getSettingValue('NAME');
    const TABLE_FIELDS = TABLE.getSettingValue('FIELDS');
    const FIELD_NAME = feature.getSettingValue('FIELD_NAME');
    const OPERATOR = feature.getSettingValue('OPERATOR');
    const FIELDS = feature.getSettingValue('FIELDS');
    const VALUE = feature.getSettingValue('VALUE');

    blocks.push({
        location: 'GLOBAL_DECLARATIONS',
        blockType: BlockType.CODE,
        id: 'declare_table_update_find_result_index',
        template: `
let table_update_find_result_index
let tmp_table_update_find_result_index`,
    });

    const doneLinks = project.getNodeLinks(feature, 'done');
    const doneBlock = doneLinks.length > 0 ? `/****${doneLinks[0].getSourceId()}****/` : '';
    const links = project.getNodeLinks(feature, 'tbl_update');
    for (let i = 0; i < links.length; i += 1) {
        const link = links[i];

        const find_index = '0';
        let updateCode = '';
        const source: BaseNode = project.getFeature(link.getSettingValue('SOURCE_FEATURE')) as BaseNode;
        const sourceParams = source.getPort(link.getSettingValue('SOURCE_PORT'))?.params;

        for (let j = 0; j < FIELDS.length; j += 1) {
            const field = FIELDS[j];

            const fieldName = field.getSettingValue('FIELD');
            let fieldValue = project.parseCodeExpression(field.getSettingValue('VALUE'), sourceParams, TibboDataType.STRING);
            for (let k = 0; k < TABLE_FIELDS.length; k += 1) {
                if (TABLE_FIELDS[k].getSettingValue('NAME') === FIELD_NAME) {
                    const field = TABLE_FIELDS[k];
                    const fieldDataType = field.getSettingValue('FIELDTYPE');
                    switch (fieldDataType) {
                        case 'E': // Timestamp
                            fieldValue = `lstr(${project.parseCodeExpression(fieldValue, sourceParams, TibboDataType.DATETIME)})`;
                            break;
                        case 'M': // Time in seconds
                            fieldValue = `fstr(${project.parseCodeExpression(fieldValue, sourceParams, TibboDataType.TIME)})`;
                            break;
                        default:

                            break;
                    }
                    break;
                }
            }

            updateCode += `
${fieldName}: ${fieldValue},`;
        }

        const valueCode = project.parseCodeExpression(VALUE, sourceParams, TibboDataType.STRING);

        let selectorCode = `tbl_record_find_sorted(EN_TBL_RECORD_ACTIVE,${valueCode},"${FIELD_NAME}",table_update_find_result_index,NO,${OPERATOR})`;
        if (OPERATOR === 'PL_FD_FIND_EQUAL') {
            selectorCode = `tbl_record_find_sorted(EN_TBL_RECORD_ACTIVE,${valueCode},"${FIELD_NAME}",table_update_find_result_index,NO,${OPERATOR})`;
        }

        blocks.push({
            location: link.getSourceId(),
            blockType: BlockType.CODE,
            id: link.getID(),
            template: `
    tmp_table_update_find_result_index = ${find_index} + 1
    table_update_find_result_index = ${find_index} + 1
    const table_find_result_index = ${selectorCode}

if (table_find_result_index !== -1
&& table_find_result_index >= 0
&& table_find_result_index < simulator.tables["${TABLE_NAME}"].length
) {
        const row = getTableRow("${TABLE_NAME}",table_update_find_result_index)

        simulator.tables["${TABLE_NAME}"][table_find_result_index] = {
            ...row,
            ${updateCode}
        };
    } else {
        console.log("No record found");
}`,
        });
    }

    return blocks;
}
